import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';


export type SaveMetaInspectionFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: SaveMetaInspectionFormProps) => {
  const [
    fnSaveMetaInspectionForm,
    { loading }
  ] = ds.useSaveMetaInspection();
  const form = ds.useFormState(props.id);
  const handleSubmit = async (formState: typeof form.formState) => {
    const input = {
      ...formState
    };
    await fnSaveMetaInspectionForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <StyledTextField.FC
        {...form.genFieldProps('notesForClient')}
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
